<div class="desktop">
  <ng-container *ngTemplateOutlet="desktop"></ng-container>
</div>
<div class="mobile">
  <ng-container *ngTemplateOutlet="mobile"></ng-container>
</div>

<ng-template #desktop>
  <div class="bonus-card card">
    <div class="bonus-card__section">
      <div class="bonus-card__section--info">
        <div class="bonus-card__section--info__title">
          {{ translateKeys?.title | translate }}
        </div>
        <div class="bonus-card__section--info__desc">
          {{ translateKeys?.desc | translate }}
        </div>
        <div class="bonus-card__section--info__confirm">
          <img src="/assets/img/confirm.png" alt="">
          {{ translateKeys?.confirm | translate }}
        </div>
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--action">
        <div class="bonus-card__section--action__button">
          <button (click)="onConfirm()" class="btn small">
            {{ translateKeys?.confirm_email | translate }}
          </button>
        </div>
        <div class="bonus-card__section--action__status">
          {{ translateKeys?.status | translate }}
        </div>
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--image">
        <img src="/assets/img/ndfs.png" alt="">
      </div>
    </div>
  </div>
</ng-template>
<ng-template #mobile>
  <div class="bonus-card card">
    <div class="bonus-card__section">
      <div class="bonus-card__section--top">
        <div class="bonus-card__section--info">
          <div class="bonus-card__section--info__title">
            {{ translateKeys?.title | translate }}
          </div>
          <div class="bonus-card__section--info__desc">
            {{ translateKeys?.desc | translate }}
          </div>
        </div>
        <div class="bonus-card__section--image">
          <img src="/assets/img/ndfs.png" alt="">
          <div class="bonus-card__section--status">
            {{ translateKeys?.status | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--confirm">
        <img src="/assets/img/confirm.png" alt="">
        {{ translateKeys?.confirm | translate }}
      </div>
    </div>
    <div class="bonus-card__section">
      <div class="bonus-card__section--action">
        <button (click)="onConfirm()" class="btn small">
          {{ translateKeys?.confirm_email | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
